import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDocumentUpload } from 'Core/hooks';
import CustomPropTypes from 'CustomPropTypes';

const initData = {
  id: 0,
  fileCategory: '',
  fileCategoryId: 0,
  fileName: '',
  filePath: '',
};

const FileTable = ({ data, onChanges }) => {
  const fileCategories = [
    { id: 1, value: 'Invoice' },
    { id: 2, value: 'Packing List' },
    { id: 3, value: 'Bill of Lading' },
    { id: 4, value: 'Certificate of Origin' },
    { id: 5, value: 'Manifest' },
  ];

  const [selectedFiles, setSelectedFiles] = useState(data || []);
  const [tempFile, setTempFile] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('');
  const { uploadDocuments, loading } = useDocumentUpload();

  useEffect(() => {
    setSelectedFiles(data || []);
  }, [data]);

  const handleFileUpload = e => {
    const file = e.target.files[0];
    if (file && selectedCategory) {
      const selectedCategoryObj = fileCategories.find(cat => cat.value === selectedCategory);
      setTempFile({
        file,
        fileCategoryId: selectedCategoryObj?.id || 0,
        fileCategory: selectedCategory,
      });
    }
  };

  const handleAdd = async () => {
    if (!tempFile) return;

    const formData = new FormData();
    formData.append('file', tempFile.file);
    formData.append('fileCategoryId', tempFile.fileCategoryId);

    const result = await uploadDocuments(formData);
    if (result) {
      const newFile = {
        id: Math.floor(Math.random() * 101),
        fileCategory: tempFile.fileCategory,
        fileCategoryId: tempFile.fileCategoryId,
        fileName: result.fileName,
        filePath: result.filePath,
      };

      const newFiles = [...selectedFiles, newFile];
      setSelectedFiles(newFiles);
      if (onChanges) onChanges(newFiles);

      setTempFile(null);
      setSelectedCategory('');
    }
  };

  return (
    <div className="row border">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">File List</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th colSpan="4">
                      <div className="d-flex gap-3 align-items-center">
                        <select
                          value={selectedCategory}
                          onChange={e => setSelectedCategory(e.target.value)}
                          className="form-control"
                        >
                          <option value="">Select File Category</option>
                          {fileCategories.map(category => (
                            <option key={category.id} value={category.value}>
                              {category.value}
                            </option>
                          ))}
                        </select>

                        <input type="file" onChange={handleFileUpload} className="form-control" />

                        <button
                          type="button"
                          className="btn btn-info"
                          onClick={handleAdd}
                          disabled={loading || !tempFile}
                        >
                          {loading ? 'Uploading...' : 'Add'}
                        </button>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th>File Category</th>
                    <th>File Name</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {selectedFiles.map((file, index) => (
                    <tr key={index}>
                      <td className="">{file.fileCategory}</td>
                      <td className="">{file.fileName}</td>
                      <td className="border p-1">
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            const newFiles = selectedFiles.filter((_, i) => i !== index);
                            setSelectedFiles(newFiles);
                            if (onChanges) onChanges(newFiles);
                          }}
                          className="btn btn-icon btn-sm btn-soft-danger rounded-pill"
                        >
                          <i className="feather-trash"></i>
                        </a>
                      </td>
                      <td className="border p-1">
                        <a
                          href="javascript:void(0);"
                          className="btn btn-icon btn-sm btn-soft-success rounded-pill"
                        >
                          <i className="feather-download"></i>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FileTable.defaultProps = {
  onChanges: () => {},
  data: [],
};

FileTable.propTypes = {
  onChanges: PropTypes.func,
  data: CustomPropTypes.Files,
};

export default FileTable;
